"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var WindowSimulationConverter_1 = require("../../../window/conversions/WindowSimulationConverter");

var NSimulationWindowDTO_1 = require("../model/NSimulationWindowDTO");

var NSimulationWindowDTOConverter_1 = require("./NSimulationWindowDTOConverter");
/**
 * @author Tomas Leity
 */


var NSimulationWindowDTOConverterImpl =
/*#__PURE__*/
function (_NSimulationWindowDTO) {
  _inherits(NSimulationWindowDTOConverterImpl, _NSimulationWindowDTO);

  /**
   * @param windowSimConverter
   */
  function NSimulationWindowDTOConverterImpl(windowSimConverter) {
    var _this;

    _classCallCheck(this, NSimulationWindowDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationWindowDTOConverterImpl).call(this));
    _this.windowSimConverter = windowSimConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NSimulationWindowDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NSimulationWindowDTO_1.NSimulationWindowDTO(NSimulationWindowDTO_1.NSimulationWindowDTO.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), NSimulationWindowDTO_1.NSimulationWindowDTO.schema.windowName.valueOf(source.windowName), NSimulationWindowDTO_1.NSimulationWindowDTO.schema.windowExternalId.valueOf(source.windowExternalId), NSimulationWindowDTO_1.NSimulationWindowDTO.schema.simulation.valueOf(conversions.asObject(source, 'simulation', function (obj) {
        return _this2.windowSimConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        windowName: source.windowName,
        windowExternalId: source.windowExternalId,
        simulation: conversions.asObject(source, 'simulation', function (obj) {
          return _this3.windowSimConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NSimulationWindowDTOConverterImpl;
}(NSimulationWindowDTOConverter_1.NSimulationWindowDTOConverter);
/**
 * IOC Container qualifier
 */


NSimulationWindowDTOConverterImpl.QUALIFIER = {
  documentType: NSimulationWindowDTO_1.NSimulationWindowDTO.name
};
NSimulationWindowDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowSimulationConverter_1.WindowSimulationConverter])], NSimulationWindowDTOConverterImpl);
exports.NSimulationWindowDTOConverterImpl = NSimulationWindowDTOConverterImpl;